import type { BankAccount, BankConnectionProviderType, BankConnectionSchema } from "bankconnect";
import type { IntlShape } from "react-intl";

import { MESSAGES } from "./message-definitions";

export type SelectedAccount = {
  connection: BankConnectionSchema;
  account: BankAccount;
};

export const PROVIDER_LABELS: Record<BankConnectionProviderType, string> = {
  plaid: "Plaid",
  basiq: "Basiq",
  truelayer: "TrueLayer",
  wayflyer: "Wayflyer",
  mocked: "Mocked",
};

export const capitalize = (value: string) => value.charAt(0).toUpperCase() + value.slice(1);

export const getAccountLabel = (intl: IntlShape, connection: BankConnectionSchema, account: BankAccount): string => {
  const institutionLabel = connection.institutionName || intl.formatMessage(MESSAGES.businessAccountFallback);
  return account.mask ? `${institutionLabel} ··${account.mask}` : institutionLabel;
};

export const getConnectedSubtitle = (intl: IntlShape, connection: BankConnectionSchema, account: BankAccount): string =>
  account.currency
    ? intl.formatMessage(MESSAGES.connectedWithProvider, {
        provider: PROVIDER_LABELS[connection.providerType],
        currency: account.currency,
      })
    : intl.formatMessage(MESSAGES.connectedWithProviderNoCurrency, {
        provider: PROVIDER_LABELS[connection.providerType],
      });
